import { Modal } from '@clientbase/clientbase-library'
import BodyModalNewChargeOrRecurrence, {
  ChargeBodyModalClientProps
} from 'templates/Customers/Modals/BodyModalNewChargeOrRecurrence/BodyModalNewChargeOrRecurrence'

type ModalNewRecurrenceProps = {
  isOpenModalNewRecurrence: boolean
} & Omit<ChargeBodyModalClientProps, 'customers' | 'groups'>

const ModalNewRecurrence = ({
  isOpenModalNewRecurrence,
  handleCloseModal,
  ...rest
}: ModalNewRecurrenceProps) => {
  return (
    <Modal
      handleClose={handleCloseModal}
      open={isOpenModalNewRecurrence}
      width="100%"
      maxWidth="80vw"
      maxHeight="90vh"
      height="auto"
    >
      <BodyModalNewChargeOrRecurrence
        isCharge={false}
        handleCloseModal={handleCloseModal}
        {...rest}
      />
    </Modal>
  )
}

export default ModalNewRecurrence
